import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Checkout.css';

const Checkout = () => {
  const { cart, cartTotal, clearCart } = useCart();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    email: '',
    cardNumber: '',
    expiry: '',
    cvc: '',
    name: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'cardNumber') {
      const v = value.replace(/\D/g, '').slice(0, 16);
      setForm((f) => ({ ...f, [name]: v.replace(/(.{4})/g, '$1 ').trim() }));
    } else if (name === 'expiry') {
      let v = value.replace(/\D/g, '');
      if (v.length >= 2) v = v.slice(0, 2) + '/' + v.slice(2, 4);
      setForm((f) => ({ ...f, [name]: v }));
    } else if (name === 'cvc') {
      setForm((f) => ({ ...f, [name]: value.replace(/\D/g, '').slice(0, 4) }));
    } else {
      setForm((f) => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (step === 1) {
      setStep(2);
    } else {
      clearCart();
      navigate('/checkout/success');
    }
  };

  if (cart.length === 0 && step < 3) {
    return (
      <div className="checkout-empty">
        <h3>Your cart is empty</h3>
        <Link to="/show-all-products">Browse Products</Link>
      </div>
    );
  }

  if (step === 2) {
    return (
      <div className="checkout-container">
        <div className="checkout-header">
          <span className="mock-badge">Secure Checkout</span>
          <h2>Payment</h2>
        </div>
        <form onSubmit={handleSubmit} className="payment-form">
          <div className="form-group">
            <label>Card number</label>
            <input
              type="text"
              name="cardNumber"
              value={form.cardNumber}
              onChange={handleChange}
              placeholder="4242 4242 4242 4242"
              maxLength={19}
              required
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Expiry</label>
              <input
                type="text"
                name="expiry"
                value={form.expiry}
                onChange={handleChange}
                placeholder="MM/YY"
                maxLength={5}
                required
              />
            </div>
            <div className="form-group">
              <label>CVC</label>
              <input
                type="text"
                name="cvc"
                value={form.cvc}
                onChange={handleChange}
                placeholder="123"
                maxLength={4}
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label>Name on card</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="John Doe"
              required
            />
          </div>
          <div className="order-summary">
            <p>Order total: <strong>${cartTotal.toFixed(2)}</strong></p>
          </div>
          <p className="mock-notice">This is a demo. No real payment is processed.</p>
          <button type="submit" className="btn btn-primary btn-pay">
            Pay ${cartTotal.toFixed(2)}
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="checkout-container">
      <div className="checkout-header">
        <span className="mock-badge">Secure Checkout</span>
        <h2>Contact & Shipping</h2>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="you@example.com"
            required
          />
        </div>
        <div className="order-summary">
          <p>Items: {cart.length}</p>
          <p><strong>Total: ${cartTotal.toFixed(2)}</strong></p>
        </div>
        <button type="submit" className="btn btn-primary">
          Continue to Payment
        </button>
      </form>
    </div>
  );
};

export default Checkout;
